<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.ijapName" style="width: 140px;" size="small" placeholder="请输入岗位名称"
                        clearable></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen"
                      >新增岗位</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="ijapId"
                        style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增/编辑弹窗 -->
            <el-dialog :title="edit ? '编辑岗位' : '新增岗位'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="岗位名称" prop="ijapName">
                            <el-input v-model="form.ijapName" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="排序" prop="ijapOrder">
                            <el-input v-model="form.ijapOrder" type="number" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getIvJobApplicantPostList,
    addIvJobApplicantPost,
    updateIvJobApplicantPost,
    deleteIvJobApplicantPost,
} from "../../api/api";

export default {
    name: "jobPost",
    data() {
        return {
            dialog: false,
            edit: false,
            form: {
                ijapName: '',
                ijapOrder: '',
            },
            rules: {
                ijapName: [
                    { required: true, message: '请输入岗位名称', trigger: 'blur' }
                ]
            },
            totalCount: 0,
            windheight: "",
            tableHight: 520,
            watchFlag: false,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ijapName",
                    key: "ijapName",
                    fixed: 'left',
                    title: "岗位名称",
                    width: 200,
                    align: "center",
                },
                {
                    field: "ijapOrder",
                    key: "ijapOrder",
                    title: "排序",
                    width: 100,
                    align: "center",
                },
                { field: "createusername", key: "createusername", title: "创建人", width: 160, align: "center" },
                { field: "createtime", key: "createtime", title: "创建时间", width: 180, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 150,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                ijapName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    methods: {
        // 删除
        handleDelete(row) {
            this.$confirm("是否确定要删除该岗位, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvJobApplicantPost({ ijapId: row.ijapId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.partserch();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        // 编辑
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row));
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            });
        },
        // 确认按钮
        SureBtn() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (!this.edit) {
                        // 新增
                        this.$confirm("是否确定要新增该岗位, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                            .then(() => {
                                addIvJobApplicantPost(this.form).then(res => {
                                    if (res.data) {
                                        this.$message({
                                            type: "success",
                                            message: "新增成功!",
                                        });
                                        this.handleClose();
                                        this.getList();
                                    }
                                });
                            }).catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消",
                                });
                            });
                    } else {
                        // 编辑
                        this.$confirm("是否确定要编辑该岗位, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                            .then(() => {
                                updateIvJobApplicantPost(this.form).then(res => {
                                    if (res.data) {
                                        this.$message({
                                            type: "success",
                                            message: "编辑成功!",
                                        });
                                        this.handleClose();
                                        this.getList();
                                    }
                                });
                            }).catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消",
                                });
                            });
                    }
                }
            });
        },
        // 打开新增弹窗
        BoxOpen() {
            this.dialog = true;
            this.edit = false;
            this.form = {
                ijapName: '',
                ijapOrder: '',
            };
        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 分页大小改变
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        // 页码改变
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getIvJobApplicantPostList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        // 搜索
        partserch() {
            this.formDatas.currentPage = 1;
            getIvJobApplicantPostList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        // 获取列表
        getList() {
            getIvJobApplicantPostList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
